// ADE Story Studio — registry condiviso tra editor e viewer.

export const FONTS = [
  { id: "display", label: "ADE", css: "'Poppins', system-ui, sans-serif", weight: 900, spacing: "-0.02em" },
  { id: "serif", label: "Editoriale", css: "Georgia, 'Times New Roman', serif", weight: 700, spacing: "0" },
  { id: "mono", label: "Tech", css: "ui-monospace, 'SF Mono', monospace", weight: 700, spacing: "0.04em" },
  { id: "hand", label: "Firma", css: "'Brush Script MT', cursive", weight: 400, spacing: "0" },
  { id: "wide", label: "Poster", css: "'Poppins', system-ui, sans-serif", weight: 800, spacing: "0.22em" },
];

export const TEXT_STYLES = [
  { id: "plain", label: "Semplice" },
  { id: "pill", label: "Pillola" },
  { id: "neon", label: "Neon" },
  { id: "gradient", label: "ADE Gradient" },
  { id: "outline", label: "Contorno" },
];

export const PALETTE = [
  "#FFFFFF", "#0B0B12", "#FF3B5C", "#FF6FA5", "#FFD166",
  "#4FD1FF", "#7B2CFF", "#34C759", "#FF8A00", "#C77DFF",
];

export const FILTERS = [
  { id: "none", label: "Originale", css: "" },
  { id: "ade", label: "ADE", css: "saturate(1.35) contrast(1.12) brightness(1.03)" },
  { id: "cinema", label: "Cinema", css: "contrast(1.28) saturate(0.9) brightness(0.96)" },
  { id: "neon", label: "Neon", css: "saturate(1.7) hue-rotate(-12deg) contrast(1.15)" },
  { id: "noir", label: "Noir", css: "grayscale(1) contrast(1.3)" },
  { id: "vhs", label: "VHS", css: "saturate(1.5) sepia(0.18) contrast(1.1)" },
  { id: "frost", label: "Frost", css: "brightness(1.08) saturate(0.75) hue-rotate(8deg)" },
  { id: "sunset", label: "Sunset", css: "sepia(0.28) saturate(1.5) contrast(1.05)" },
];

export const EMOJI_PACK = [
  "🔥", "❤️", "😍", "😂", "🤩", "😎", "🥳", "👏", "💯", "✨",
  "🌊", "🌴", "🍸", "🎧", "⚡", "🌙", "☀️", "🏝️", "💎", "🚀",
];

export const ADE_STICKER_PACK = [
  { id: "ade_logo", label: "ADE", kind: "logo" },
  { id: "ade_here", label: "HERE", kind: "badge" },
  { id: "ade_mood", label: "MOOD", kind: "badge" },
  { id: "ade_island", label: "ISLAND", kind: "badge" },
  { id: "ade_live", label: "LIVE", kind: "pulse" },
  { id: "ade_new", label: "NEW", kind: "pulse" },
];

export const DRAW_COLORS = ["#FFFFFF", "#FF3B5C", "#FFD166", "#4FD1FF", "#7B2CFF", "#34C759", "#0B0B12"];
export const DRAW_WIDTHS = [3, 7, 14];

export const MAX_STORY_SECONDS = 30;

export const newId = (prefix) => `${prefix}_${Math.random().toString(36).slice(2, 9)}`;

export const fontOf = (id) => FONTS.find((f) => f.id === id) || FONTS[0];
export const filterCss = (id) => (FILTERS.find((f) => f.id === id) || FILTERS[0]).css;

// Stile del testo → proprietà CSS (condiviso editor/viewer per rendering identico)
const contrastOn = (hex) => {
  try {
    const h = (hex || "#ffffff").replace("#", "");
    const r = parseInt(h.slice(0, 2), 16), g = parseInt(h.slice(2, 4), 16), b = parseInt(h.slice(4, 6), 16);
    return (r * 299 + g * 587 + b * 114) / 1000 > 150 ? "#0B0B12" : "#FFFFFF";
  } catch { return "#0B0B12"; }
};

export function textStyleProps(el) {
  const f = fontOf(el.font);
  const base = {
    fontFamily: f.css,
    fontWeight: f.weight,
    letterSpacing: f.spacing,
    color: el.color || "#fff",
    textAlign: "center",
    lineHeight: 1.12,
    padding: "6px 12px",
    borderRadius: 14,
    whiteSpace: "pre-wrap",
  };
  switch (el.style) {
    case "pill":
      return { ...base, background: el.bgColor || "#ffffff", color: contrastOn(el.bgColor) };
    case "neon":
      return {
        ...base,
        color: "#fff",
        textShadow: `0 0 6px ${el.color}, 0 0 18px ${el.color}, 0 0 36px ${el.color}`,
      };
    case "gradient":
      return {
        ...base,
        background: "linear-gradient(92deg, #FF8A00, #FF3B5C 45%, #7B2CFF)",
        WebkitBackgroundClip: "text",
        backgroundClip: "text",
        color: "transparent",
        filter: "drop-shadow(0 2px 10px rgba(255,59,92,0.45))",
      };
    case "outline":
      return {
        ...base,
        color: "transparent",
        WebkitTextStroke: `1.6px ${el.color || "#fff"}`,
      };
    default:
      return { ...base, textShadow: "0 2px 12px rgba(0,0,0,0.55)" };
  }
}

export function countdownParts(targetIso) {
  const ms = new Date(targetIso).getTime() - Date.now();
  if (!Number.isFinite(ms)) return null;
  const clamped = Math.max(0, ms);
  return {
    done: clamped === 0,
    d: Math.floor(clamped / 86400000),
    h: Math.floor((clamped % 86400000) / 3600000),
    m: Math.floor((clamped % 3600000) / 60000),
    s: Math.floor((clamped % 60000) / 1000),
  };
}
